import { Grid2, Stack, Typography } from "@mui/material";
import { ChangeEvent, useCallback } from "react";
import { useUpdateStateMutation } from "src/api/services/api";
import { States } from "src/api/types";
import StyledSwitch from "src/components/StyledSwitch";

interface Props {
  activeState: States;
}

const ActiveState = ({ activeState }: Props) => {
  const [updateState] = useUpdateStateMutation();
  const handleStateStatusSwitch = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      const updatedState = {
        id: activeState.id,
        active: event.target.checked,
      };

      updateState(updatedState);
    },
    [activeState.id, updateState]
  );

  return (
    <Grid2 size={3}>
      <Stack
        direction="row"
        alignItems="center"
        role="group"
        justifyContent="space-between"
      >
        <Typography variant="h6" id={`label-${activeState.id}`}>
          {activeState.name}
        </Typography>
        <StyledSwitch
          slotProps={{
            input: { "aria-labelledby": `label-${activeState.id}` },
          }}
          checked={activeState.active}
          onChange={handleStateStatusSwitch}
        />
      </Stack>
    </Grid2>
  );
};

export default ActiveState;
